module.exports = __webpack_public_path__ + "static/media/scan.a3b019cc.png";